<template>
  <div class="policy-container">
    <div class="policy-header">
      <div class="policy-title">
        <h1 class="title">{{ $t('legal.terms.paragraph_001') }}</h1>
      </div>
    </div>
    <div class="policy-content policy-content-top">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_002') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_003') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_004') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_005') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_006') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_007') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_008') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_009') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_010') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_011') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_012') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_013') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_014') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_015') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_016') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_017') }}<br/>{{ $t('legal.terms.paragraph_018') }}<br/>{{ $t('legal.terms.paragraph_019') }}<br/>{{ $t('legal.terms.paragraph_020') }}<br/>{{ $t('legal.terms.paragraph_021') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_022') }}<br/>{{ $t('legal.terms.paragraph_023') }}<br/>{{ $t('legal.terms.paragraph_024') }}<br/>{{ $t('legal.terms.paragraph_025') }}<br/>{{ $t('legal.terms.paragraph_026') }}<br/>{{ $t('legal.terms.paragraph_027') }}<br/>{{ $t('legal.terms.paragraph_028') }}<br/>{{ $t('legal.terms.paragraph_029') }}<br/>{{ $t('legal.terms.paragraph_030') }}<br/>{{ $t('legal.terms.paragraph_031') }}<br/>{{ $t('legal.terms.paragraph_032') }}<br/>{{ $t('legal.terms.paragraph_033') }}<br/>{{ $t('legal.terms.paragraph_034') }}<br/>{{ $t('legal.terms.paragraph_035') }}<br/>{{ $t('legal.terms.paragraph_036') }}<br/>{{ $t('legal.terms.paragraph_037') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_038') }}<br/>{{ $t('legal.agreement.paragraph_023') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_040') }}<br/>{{ $t('legal.terms.paragraph_041') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_042') }}<br/>{{ $t('legal.terms.paragraph_043') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_044') }}<br/>{{ $t('legal.terms.paragraph_045') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_046') }}<br/>{{ $t('legal.terms.paragraph_047') }}<br/>{{ $t('legal.terms.paragraph_048') }}<br/>{{ $t('legal.terms.paragraph_049') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_050') }}<br/>{{ $t('legal.terms.paragraph_051') }}<br/>{{ $t('legal.terms.paragraph_052') }}<br/>{{ $t('legal.terms.paragraph_053') }}<br/>{{ $t('legal.terms.paragraph_054') }}<br/>{{ $t('legal.terms.paragraph_055') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_056') }}<br/>{{ $t('legal.terms.paragraph_057') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_058') }}<br/>{{ $t('legal.terms.paragraph_059') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_060') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_061') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_062') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_063') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_064') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_065') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_066') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_067') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_068') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_069') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_070') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_071') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_072') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_073') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_074') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_075') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_076') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_077') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_078') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_079') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_080') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_081') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_082') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_083') }}<br/>{{ $t('legal.terms.paragraph_084') }}<br/>{{ $t('legal.terms.paragraph_085') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_086') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_087') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_088') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_089') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_090') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_091') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_092') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_093') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_094') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_095') }}<br/>{{ $t('legal.terms.paragraph_096') }}<br/>{{ $t('legal.terms.paragraph_097') }}<br/>{{ $t('legal.terms.paragraph_098') }}<br/>{{ $t('legal.terms.paragraph_099') }}<br/>{{ $t('legal.terms.paragraph_100') }}<br/>{{ $t('legal.terms.paragraph_101') }}<br/>{{ $t('legal.terms.paragraph_102') }}<br/>{{ $t('legal.terms.paragraph_103') }}<br/>{{ $t('legal.terms.paragraph_104') }}<br/>{{ $t('legal.terms.paragraph_105') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_106') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_107') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_108') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_109') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_110') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_111') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_112') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_113') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_114') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_115') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_116') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_117') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_118') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_119') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_120') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_121') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_122') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_123') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_124') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_125') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_126') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_127') }}</p>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_128') }}</p>
    </div>
    <div class="policy-content">
      <div class="title-border"></div>
      <h2 class="policy-content-title">{{ $t('legal.terms.paragraph_129') }}</h2>
      <p class="policy-text sm:mt-24px mt-2vw">{{ $t('legal.terms.paragraph_130') }}</p>
      <ul class="policy-text mt-6vw mb-5vw">
        <li>{{ $t('legal.terms.paragraph_131') }}</li>
        <li>{{ $t('legal.terms.paragraph_132') }}</li>
        <li>{{ $t('legal.terms.paragraph_133') }}</li>
        <li>{{ $t('legal.terms.paragraph_134') }}</li>
        <li>{{ $t('legal.terms.paragraph_135') }}</li>
        <li class="mt-6vw" style="color: #aaa;">{{ $t('legal.terms.paragraph_136') }}</li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  components: {}
}
</script>

<style scoped>
.policy-container {
  padding: 6vh 0 0;
}
.policy-header {
  padding: 11vh 0 8vh 0;
  background-color: #163257;
}
.policy-title {
  padding: 1rem 5rem;
  margin-left: auto;
  margin-right: auto;
  width: 90%;
}
.title {
  font-size: 52px;
  text-align: left;
  font-weight: 500;
  text-transform: uppercase;
  color: #ffffff;
  line-height: 56px;
  margin-top: 20px;
  width: 100%;
  text-shadow: 0px 2px 20px rgba(0, 0, 0, 0.3);
}
.policy-content-top {
  margin-top: 4vw;
}
.policy-content {
  margin-left: auto;
  margin-right: auto;
  width: 90%;
  padding: 2rem 5rem 1rem 5rem;
}
.policy-content-title {
  font-size: 28px;
  font-weight: 500;
  color: #163257;
  line-height: 30px;
}
.title-border {
  padding-bottom: 20px;
  width: 70px;
  border-top: 4px solid #f1dba8;
}
.policy-text {
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  line-height: 28px;
}
.subTitle {
  width: 862px;
  height: 64px;
  font-size: 24px;
  font-weight: 300;
  color: #ffffff;
  line-height: 32px;
  margin: 20px auto 0;
  text-align: center;
  text-shadow: 2px 2px gray;
}
.faq-bottom {
  margin-left: auto;
  margin-right: auto;
  width: 90%;
  margin: 0 auto;
  padding: 2rem 5rem 0 5rem;
}
.marginTop16 {
  margin-top: 15px;
}
.marginTop48 {
  margin-top: 48px;
}
@media only screen and (max-width: 600px){
.policy-container {
  padding: 0;
}
.policy-header {
  padding: 5vh 0;
  background-color: #163257;
}
.policy-title {
  padding: 1rem 2rem;
}
.title {
  font-size: 2rem;
  text-align: center;
  font-weight: 500;
  text-transform: uppercase;
  color: #ffffff;
  line-height: 3rem;
  margin-top: 7vw;
  text-shadow: 0px 2px 20px rgba(0, 0, 0, 0.3);
}
.policy-content {
  padding: 6vw 2vw;
}
.policy-content-top {
  margin-top: 8vw;
}
.policy-content-title {
  font-size: 18px;
  line-height: 30px;
}
.policy-text {
  font-size: 16px;
}
.title-border {
  padding-bottom: 10px;
  width: 50px;
}
.subTitle {
  width: 100%;
  height: auto;
  font-size: 1rem;
  font-weight: 400;
  color: #ffffff;
  padding: 0 5vw;
  line-height: 1.5rem;
  margin: 3vw auto 0;
  text-align: center;
}
.faq-bottom {
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 5vw;
}
.marginTop16 {
  margin-top: 3vw;
}
.marginTop48 {
  margin-top: 5vw;
}
}
</style>
